module.exports = __webpack_public_path__ + "img/maximiliano_frega.73d12edb.png";